/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { ReactComponent as PlusRegularIcon } from "assets/images/icons/common/plus-regular-brand.svg";
const AddImageButton = (props) => {
    const { setOpen } = props;
    
    return (
        <Fragment>
            <div className="default-image-selector" onClick={() => setOpen(true)}>
                <div className="default-image-selector-icon">
                    <PlusRegularIcon /> 
                </div>
                <div className="default-image-selector-label">Select image</div>
            </div>
        </Fragment>
    );
};
export { AddImageButton };
